import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class TriggerInputValidator extends BaseValidator {
  validatorRules = {
    threshold: {
      required: true,
      type    : BaseValidator.Type.Number
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
